import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import getKhattabatStore from "../../../stores/khattabat-stores";
import { isPositiveNumber, reduce } from "et3-type-guards";
import Et3Text from "../../../core/et3-text";
import getCorePersonalStore from "../../../stores/core/core-personal-store";

const ClientChevron = withLiteObserverAndTheme<{
  alkhattabaUUID: string;
  userUUID: string;
  unreadOneOOneCMessages: number;
  oneOOneCId: string
}>((props) => {
  const { theme, userUUID, alkhattabaUUID, unreadOneOOneCMessages, oneOOneCId } = props;
  const { colors } = theme;

  const clientConversationsId = oneOOneCId
  const haveUnreadMessages = isPositiveNumber(unreadOneOOneCMessages);
  const shouldShowConversations = reduce(
    () =>
      getKhattabatStore().clientConversations.get(clientConversationsId)
        .shouldShowConversations,
    false
  );
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get()
  const shouldHideUnreadMessageCounter = isAiKhattaba || !haveUnreadMessages


  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={80}
      height={80}
      color={colors.all.transparent}
      style={{ cursor: "pointer" }}
      onClick={() => {
        return shouldShowConversations
          ? getKhattabatStore().closeClientConversations({
            clientConversationsId
          })
          : getKhattabatStore().getClientConversations({
            alkhattabaUUID,
            userUUID,
            shouldLoad: true,
            oneOOneCId
          });
      }}
    >
      {shouldHideUnreadMessageCounter ? null : (
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={30}
          text={`${unreadOneOOneCMessages}`}
          isSpan={false}
          color={colors.all.red}
          style={{
            border: `1px solid ${colors.all.red}`,
            padding: 5
          }}
        />
      )}
      <Et3Margin top={0} bottom={0} left={10} right={10} />
      <FontAwesomeIcon
        icon={!shouldShowConversations ? faChevronDown : faChevronUp}
        style={{ color: colors.all.blue }}
      />
      <Et3Margin top={0} left={10} bottom={0} right={0} />
    </ET3Div>
  );
});
export default ClientChevron;
